// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__2gmsb","footer":"ModalCreateQualiphyProcedure_footer__xngRf","additionData":"ModalCreateQualiphyProcedure_additionData__2L6p1"};